export enum DateVisualDataType {
  Date = 'Date',
}

export enum NumericVisualDataType {
  Number = 'Number',
  Monetary = 'Monetary',
  Percentage = 'Percentage',
}

export enum BooleanVisualDataType {
  Boolean = 'Boolean',
}

export enum AddressVisualDataType {
  Address = 'Address',
}

export enum TableVisualDataType {
  Table = 'Table',
}

export enum StringVisualDataType {
  List = 'List',
  Text = 'Text',
  LargeText = 'LargeText',
  PhoneNumber = 'PhoneNumber',
  EmailAddress = 'EmailAddress',
  IdentificationNumber = 'IdentificationNumber',
}

export type BasicVisualDataType =
  | NumericVisualDataType
  | StringVisualDataType
  | BooleanVisualDataType
  | DateVisualDataType
  | AddressVisualDataType;

export type ComplexVisualDataType =
  | TableVisualDataType;

export type VisualDataType = BasicVisualDataType | ComplexVisualDataType;
